import React from "react";

import {
  doFlex,
  padT40,
  contactDepartments,
  flexWrap,
  mSpaceBetween,
} from './main.module.scss'


const ContactDepartments = () => {

  return (
    <div>
      <div className={`${doFlex} ${mSpaceBetween} ${padT40} ${flexWrap}`}>
        <div className={`${contactDepartments}`}>
          <h3>Sales Team</h3>
          <p>Email: <a href="mailto:sales@bigboxhost.com">sales@bigboxhost.com</a><br />
            Phone: <a href="tel:+1-916-888-2383">+1-916-888-2383</a><br /><br />
            Direct: <a href="https://bigboxhost.com/portal/submitticket.php?step=2&deptid=2">open support ticket</a>
          </p>
        </div>
        <div className={`${contactDepartments}`}>
          <h3>Support Team</h3>
          <p>Email: <a href="mailto:support@bigboxhost.com">support@bigboxhost.com</a><br />
            Phone: <a href="tel:+1-916-888-2383">+1-916-888-2383</a><br /><br />
            Direct: <a href="https://bigboxhost.com/portal/submitticket.php?step=2&deptid=1">open support ticket</a>
          </p>
        </div>
        <div className={`${contactDepartments}`}>
          <h3>Billing Team</h3>
          <p>Email: <a href="mailto:billing@bigboxhost.com">billing@bigboxhost.com</a><br />
            Direct: <a href="https://bigboxhost.com/portal/submitticket.php?step=2&deptid=4">open support ticket</a>
          </p>
        </div>
        <div className={`${contactDepartments}`}>
          <h3>Abuse Reporting</h3>
          <p>Email: <a href="mailto:abuse@bigboxhost.com">abuse@bigboxhost.com</a><br />
            Direct: <a href="https://bigboxhost.com/portal/submitticket.php?step=2&deptid=7">open support ticket</a>
          </p>
        </div>
        <div className={`${contactDepartments}`}>
          <h3>Domain Management</h3>
          <p>Email: <a href="mailto:domain@bigboxhost.com">domain@bigboxhost.com</a><br />
            Direct: <a href="https://bigboxhost.com/portal/submitticket.php?step=2&deptid=14">open support ticket</a>
          </p>
        </div>
      </div>
    </div>
  )

};

export default ContactDepartments